import React, { lazy, useEffect } from "react";
import Header from "./Header/Header";
import { lazyWithPreload } from "react-lazy-with-preload";
import LazyComponent from "components/Lazy/LazyLoad";

const Hero = lazyWithPreload(() => import("components/Hero/Hero"));
const Zigzag = lazy(() => import("components/Zigzag/Zigzag"));
const BeforeAfter = lazy(() => import("components/BeforeAfter/BeforeAfter"));
const DidYouKnow = lazy(() => import("components/DidYouKnow/DidYouKnow"));
const BenefitsSection = lazy(() => import("components/BenefitsSection/BenefitsSection"));
const ReviewSection = lazy(() => import("components/ReviewSection/ReviewSection"));
const HappyCustomersSection = lazy(() => import("components/HappyCustomersSection/HappyCustomersSection"));
const DropdownSection = lazy(() => import("components/DropdownSection/DropdownSection"));
const CustomerReviews = lazy(() => import("components/CustomerReviews/CustomerReviews"));
const Footer = lazy(() => import("../layouts/Footer/Footer"));

interface CustomWindow extends Window {
  hybridLander?: any;
}

declare let window: CustomWindow;

const Layout: React.FC = () => {
  useEffect(() => {
    Hero.preload();
    const primaryColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_primary;
    document.documentElement.style.setProperty("--primary-color", primaryColor);
    const secondaryColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_secondary;
    document.documentElement.style.setProperty("--secondary-color", secondaryColor);
    const dividersColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_dividers;
    document.documentElement.style.setProperty("--dividers-color", dividersColor);
    const lightSectionColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_lightSectionBg;
    document.documentElement.style.setProperty("--light-section-color", lightSectionColor);
    const darkSectionColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_darkSectionBg;
    document.documentElement.style.setProperty("--dark-section-color", darkSectionColor);
    const dotsColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_dots;
    document.documentElement.style.setProperty("--dots-color", dotsColor);
    const firstGradient = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_gradientOne;
    document.documentElement.style.setProperty("--first-gradient", firstGradient);
    const secondGradient = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_gradientTwo;
    document.documentElement.style.setProperty("--second-gradient", secondGradient);
    const ctaBg = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_ctaBg;
    document.documentElement.style.setProperty("--cta-bg", ctaBg);
    const ctaHover = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_ctaHover;
    document.documentElement.style.setProperty("--cta-hover", ctaHover);
    const ctaBottom = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_ctaBottomBorder;
    document.documentElement.style.setProperty("--cta-bottom", ctaBottom);
    const textColor = window?.hybridLander?.hybrid_lander_v1_colors?.hybrid_lander_v1_colors_textMainColor;
    document.documentElement.style.setProperty("--text-color", textColor);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <LazyComponent Component={Zigzag} />
        <LazyComponent Component={BeforeAfter} />
        <LazyComponent Component={DidYouKnow} />
        <LazyComponent Component={BenefitsSection} />
        <LazyComponent Component={ReviewSection} />
        <LazyComponent Component={HappyCustomersSection} />
        <LazyComponent Component={DropdownSection} />
        <LazyComponent Component={CustomerReviews} />
      </main>
      <LazyComponent Component={Footer} />
    </>
  );
};

export default Layout;
